import { useEffect } from "react";
import { RouteObject } from "react-router";
import { useLocaleNavigate } from "@ct-react/locale";
import { ArticleType } from "@shared/url";
import { articleTypes, pages } from "./i18n/sharable-defs";
import App from "./app";
import HomePage from "./pages/home";
import SearchPage from "./pages/search";
import OpenArticlePage from "./pages/open-article";
import ContactPage from "./pages/contact";
import NotFoundPage from "./pages/not-found";
import EstimatePage from "./pages/estimate";
import DefaultCmsPage from "./pages/cms";
import MailRegistrationPage from "./pages/mail-registration";
import CheckoutPage from "./pages/checkout/checkout";
import CallbackPage from "./pages/checkout/callback";
import BookmarksPage from "./pages/bookmarks";
import MakeoverIndexPage from "./pages/makeovers";
import MakeoverProjectPage from "./pages/makeovers/item";
import NewsIndexPage from "./pages/news";
import NewsItemPage from "./pages/news/item";

const LocalNavigate = ({ path }: { path: string }) => {
  const navigate = useLocaleNavigate();
  useEffect(() => { navigate(path, { replace: true }); }, [ path ]);
  return null;
}

export const withElements = (routes: RouteObject[]): RouteObject[] => routes.map(({ id, loader, ...route }) => ({
  ...route,
  ...(!!loader) && { loader, hydrateFallbackElement: <></> },
  ...(route.compId === "app" && { element: <App /> }),
  ...(route.compId === "home" && { element: <HomePage /> }),
  ...(route.path === "sales") && { asMenu: pages.sales },
  ...(route.path === "property-development") && { asMenu: pages.promos },
  ...(route.compId === "search-sale") && { element: <SearchPage type={ArticleType.SALE} />, asMenu: articleTypes.nav[ArticleType.SALE] },
  ...(route.compId === "search-sold") && { element: <SearchPage type="sold" />, asMenu: { label: articleTypes.nav["sold"], order: 4 } },
  ...(route.compId === "search-rental") && { element: <SearchPage type={ArticleType.RENTAL} />, asMenu: articleTypes.nav[ArticleType.RENTAL] },
  ...(route.path === "rentals") && { asMenu: pages.rentals },
  ...(route.compId === "article") && { element: <OpenArticlePage /> },
  ...(route.path === "renovation") && { asMenu: pages.renovation },
  ...(route.compId === "makeovers") && { element: <MakeoverIndexPage />, asMenu: { label: pages.makeovers, order: 10 } },
  ...(route.compId === "makeover") && { element: <MakeoverProjectPage /> },
  ...(route.path === "services") && { asMenu: pages.services },
  ...(route.path === "agency") && { asMenu: pages.agency },
  ...(route.compId === "news-index") && { element: <NewsIndexPage />, asMenu: pages.news },
  ...(route.compId === "news-item") && { element: <NewsItemPage />},
  ...(route.compId === "contact") && { element: <ContactPage />, asMenu: pages.contact },
  ...(route.path === "with-us") && { asMenu: pages.withUs },
  ...(route.compId === "estimate") && { element: <EstimatePage />, asMenu: { label: pages.estimate, order: 1 } },
  ...(route.compId === "default-cms") && { element: <DefaultCmsPage /> },
  ...(route.compId === "alert") && { element: <MailRegistrationPage /> },
  ...(route.compId === "checkout") && { element: <CheckoutPage /> },
  ...(route.compId === "payment-callback") && { element: <CallbackPage succeeded={route.path === "success"} /> },
  ...(route.compId === "bookmarks") && { element: <BookmarksPage /> },
  ...(route.compId === "not-found") && { element: <NotFoundPage />},
  ...(!!route.children && route.children.length > 0) && { children: withElements(route.children) }
} as unknown as RouteObject));
